<div class="topWrapper p-float-label">
  <ng-content></ng-content>
  <label>{{ fieldCaption }}</label>
</div>
